import axios from 'axios'
import config from '@/config'
import applyUrlTemplate from './applyUrlTemplate'
import applyDefaultParams from './applyDefaultParams'
import { applyCacheResuest, applyCacheResponse } from './cache'
import store from '@/store'

import normalizeAxiosError, {
// SERVER_ERROR,
// TIMEOUT_ERROR,
// NETWORK_ERROR
} from './normalizeAxiosError'
import router from '@/router'

const API_TIMEOUT = 300000 // 300s
// const API_TIMEOUT = 5000 // 30s

const partnerAdminApi = axios.create({
  baseURL: config.partnerAdminApiUrl,
  timeout: API_TIMEOUT
})

partnerAdminApi.interceptors.request.use(applyCacheResuest)
partnerAdminApi.interceptors.request.use(applyUrlTemplate)
partnerAdminApi.interceptors.request.use(applyDefaultParams)

partnerAdminApi.interceptors.response.use(applyCacheResponse)
partnerAdminApi.interceptors.response.use(null, normalizeAxiosError)
partnerAdminApi.interceptors.response.use(null, function (err) {
  console.log(err)
  if (err.status === 401) {
    router.push({path: '/login'})
  } else {
    router.push({path: '/etc/dataerror'})
  }
  return Promise.reject(err)
})

// partnerAdminApi.interceptors.response.use(function (response) {
//   if (response.data.info && response.data.info.result && response.data.info.result.code === 'FAIL') {
//     if (response.data.info.result.message === 'permission denied') {
//       alert('접근 권한이 없습니다.')
//       router.push({path: store.getters['authentication/getUserInitPage']})
//     }
//   } else {
//     if (store.getters['authentication/getRefreshTime'] === '') {
//       if (response.config.url !== 'sso/refresh')window.incrossSSO.refresh()
//     } else {p
//       let afterRefreshTime = new Date().getTime()
//       let beforeRefreshTime = store.getters['authentication/getRefreshTime'].getTime()
//       // router refresh 후 3초 지났을때 refresh 하도록 간격 제어
//       if (afterRefreshTime - beforeRefreshTime >= 3000) {
//         if (response.config.url !== 'sso/refresh')window.incrossSSO.refresh()
//       }
//     }
//     return response
//   }
// }, async function (error) {
//   router.push({path: '/etc/dataerror'})
//   return Promise.reject(error)
// })

export default partnerAdminApi
